import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { CardService } from '../../services/card.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MasterDataService } from 'app/shared/services/master-data.service';
import { Constants } from 'app/shared/constant/constants';
import { OrderItemModel, OrderRequestModel, QuotationCurrenciesRequestModel, QuotationRequestModel, QuotationResponseModel, WalletTransferRequestModel } from '../../models/card.model';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { ReqGetCurrencyMaster } from 'app/shared/models/shared-models';
import { QuotationCurrencyItem } from 'app/modules/dashboard/models/quotation.models';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { CryptoUtils } from 'app/shared/utility/crypto.utils';
import { EsignMode } from 'app/shared/constant/esign-mode';
import { RequestAadhaarEsignDetail, RequestAadhaarEsignDetailOrder } from 'app/modules/remittance/models/cart.model';
import { DomSanitizer } from '@angular/platform-browser';
import { OrderService } from 'app/modules/order/services/order.service';
import { RemittanceService } from 'app/modules/remittance/services/remittance.service';

@Component({
  selector: 'encashment',
  templateUrl: './encashment.component.html',
  encapsulation: ViewEncapsulation.None
})

export class EncashmentComponent implements OnInit {
  public tncText = "I hereby wish to refund the value of foreign exchange by debiting my WSFx Smart Currency Card. I delcare that the information included in this form is true and correct, and I have read the terms and conditions.";
  public otpForEncashment : any;
  public showLoader :boolean = false;
  public reqGetCurrencyMaster: ReqGetCurrencyMaster = new ReqGetCurrencyMaster();
  public quotationCurrencyItem: QuotationCurrencyItem = new QuotationCurrencyItem();
  public currencyItems: any;
  public bankAccountItems = [];
  public quotationDisplay: any;
  public showBankDetails: boolean = false;
  public showAddBankAccountForm: boolean = false;
  public isSurrenderOrder: boolean = false;
  public orderDetails: any;
  public issuerCode: any;



  public cardTransferList = [];
  public cardWalletList = [];
  public cardDetailsObject = [];
  public cardDetailsList = [];
  public kitId: any;

  public quotationCurrenciesList = new Array<QuotationCurrenciesRequestModel>();
  public quotationRequest = new QuotationRequestModel();
  public quotationResponse = new QuotationResponseModel();
  public orderRequestModel = new OrderRequestModel();
  public orderRequestList = new Array<OrderRequestModel>();
  //public quotationCurrencyResponsesList = [];
  public checked: boolean;
  public check: boolean;
  public isChecked: boolean = false;
  public index: any;
  public transferCurrency: any;
  public currencyBalance;
  public quotationCurrencies: QuotationCurrenciesRequestModel;
  public isQuotationAvailable = false;
  //public quotationDisplay: any;
  public quotationCurrencyResponse = [];
  public selectedBank: any;
  public selectedBankId: any;
  public transferAmount: any;
  public transferCurrencyList = new Array<WalletTransferRequestModel>();
  public orderRequest : any;
  public consumerDetail : any;
  public paxId : any;
  public encashmentFormURL : any;
  public consumerDetails:any;
  public name:any;
  public cardData;
  public cryptoUtils: CryptoUtils = new CryptoUtils();
  orderCardVendor = "";
  public showESignIframe: boolean = false;  
  public signatureMode = EsignMode.activeEsignMode;
  public url: any;
  //public encashmentOrderData;
  public esignResp: any;
  public esignUrl: any;
  orderId: any;
  forexMarginString: string;

  constructor(
    public updateProfileService : UpdateProfileService,
    public cardService: CardService,
    public toast: ToastrService,
    private masterDataService: MasterDataService,
    private router: Router,
    public orderService: OrderService,
    private remittanceService: RemittanceService,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    
  ) {
     this.route.params.subscribe((params: Params) => {
          this.orderId = params['orderId'];
              this.getSingleOrderDetails();

        });
   }

  ngOnInit() {

   
    
    // let encashmentReqData = sessionStorage.getItem(ConstantsKey.ENCASHMENT_ORDER_REQUEST_DATA)
    // if(encashmentReqData) {
    //   this.orderRequestList = JSON.parse(encashmentReqData);
    // }

    // let encasmentRespData = sessionStorage.getItem(ConstantsKey.ENCASHMENT_ORDER_RESPONSE);
    
    // if(encasmentRespData) {
    //   this.encashmentOrderData = encasmentRespData;
    // }


    
    // console.log("QUOTATION >>>>",this.quotationDisplay);
    // this.quotationCurrencyResponsesList = this.quotationDisplay["quotationCurrencyResponses"];
    // var consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    // this.consumerDetails = JSON.parse(consumerData);
    // // this.cardData = JSON.parse(sessionStorage.getItem(ConstantsKey.STUDENT_CARD_DATA));
    // this.cardData = JSON.parse(sessionStorage.getItem(ConstantsKey.WSFX_SELECTED_CARD_DATA));
    // this.orderCardVendor = this.cardData.card;
    // console.log("CARD DATA FOR CASHOUT ------------------------------- ", this.cardData);

    // // if(this.cardData.cardType == 'studentPayCard') {
    //   this.tncText.replace("Smart Currency Card", this.cardData.title);
    // // }

    // if (this.consumerDetails['firstName'] != null &&
    // this.consumerDetails['firstName'] != "") {
    //   this.name = this.consumerDetails['firstName'];
    //     } else if (this.consumerDetails['lastName'] != null &&
    //   this.consumerDetails['lastName'] != "") {
    //       this.name = this.consumerDetails['lastName'];
    //   }
    //   this.tncText="I "+this.name+" hereby wish to refund the value of foreign exchange by debiting my WSFx "+ this.cardData.title +". I declare that the information included in this form is true and correct, and I have read the";
  }

   getSingleOrderDetails() {
    this.showLoader = true;
    this.orderService.getOrderDetailsSingle(this.orderId).subscribe(respOrderData => {
      if (respOrderData['status'] == 200) {
        this.showLoader = false;
        this.orderDetails = respOrderData.body;
       
       if(this.orderDetails.sellType=='BUY' ){
        this.isSurrenderOrder=true;
        
      }
      this.issuerCode=this.orderDetails?.orderItems?.[0]['issuerCode'];
        if (this.orderDetails?.invoice?.marginCharges != null) {
          this.forexMarginString = this.orderDetails?.invoice?.marginCharges.toFixed(2) + "";
        }
         this.quotationDisplay =  JSON.parse(sessionStorage.getItem(ConstantsKey.QUOTATION_RESPONSE_FOR_ENCASHMENT));
         this.orderRequest =  JSON.parse(sessionStorage.getItem(ConstantsKey.ORDER_REQUEST));
             this.getPaxId();


      }
    }, error => {
      this.showLoader = false;
     
    });
  }
   
  getPaxId() {
    this.showLoader = true;
    this.updateProfileService.getProfileListAll().subscribe(resp => {
      this.showLoader = false;
      this.consumerDetail = resp.body;
      this.paxId = this.consumerDetail.paxResponse.id; 
      this.callEncashmentForm();

      console.log("PAX ID>>>>",this.paxId);
    });
  }

  otpRequestForEncashment(isChecked){
    if(isChecked){
    this.cardService.getEncashmentOTP({}).subscribe(resp =>{
        // this.showLoader = true;
        var responseJSON = resp.body;
        this.toast.success('OTP sent successfully !');
    }, error => {
      this.showLoader = false;
      this.toast.error(error.error.message);
    });
  }
  }
 
  // validateOTP(){
  //   if(this.isChecked){
  //   this.showLoader = true;
  //   this.cardService.validateEncashmentOTP(this.otpForEncashment, {}).subscribe(resp => {
  //     var responseJSON = resp.body;
    
  //     this.createOrder();
  //   },  error =>{
  //     this.showLoader = false;
  //     this.toast.error(error.error.message);
  //   });
  // }else{
  //   this.toast.error("Please accept terms and conditions");
  // }
  // }

   callEncashmentForm(){
  this.cardService.getEncashmentForm(this.orderRequest?.bankId, this.paxId, this.quotationDisplay.quotationSnapshotId,this.issuerCode,this.orderId).subscribe(resp=>{
    console.log("FORM", resp);
    var response = resp.body;
    // this.encashmentFormURL = response['url'];
    // window.open(this.encashmentFormURL, "_blank");
    }, error => {
      this.toast.error(error.error.message);
    });

  } 


  // createOrder() {
  //   this.cardService.createOrder(this.orderRequestList).subscribe((respCOrder) => {
  //     this.showLoader = false;
      
  //   }, (error) => {
  //     this.showLoader = false;


  //     if(error.status==200){
  //       this.quotationCurrenciesList = [];
  //       this.quotationRequest = new QuotationRequestModel();
  //       this.transferCurrencyList = [];

  //       let encashmentObject = JSON.parse(this.cryptoUtils.resDecrypt(error.error.text));
  //       console.log("ENCASHMENT RESPONSE ----- ",encashmentObject);
  //       let cardVendor = this.cardData.cardVendor;
  //       this.cardService.getEncashmentForm(this.orderRequest?.bankId, this.paxId, this.quotationDisplay.quotationSnapshotId, cardVendor, encashmentObject[0].orderId).subscribe(resp => {
  //         var response = resp.body;
  //         this.encashmentFormURL = response['url'];
  //         window.open(this.encashmentFormURL, "_blank");
  //         this.toast.success("Your encashment request is placed successfully. The amount will be transferred to your bank account within 1-2 business days.");
  //         this.router.navigate(['/my-card']);
  
  //       }, error => {
  //         this.showLoader = false;
  //         this.router.navigate(['/my-card']);
  //         this.toast.error(error.error.message);
  //       });

  //     } else {
  //       this.showLoader = false;
  //       this.toast.error(error.error.message);
  //     }
  //   });
  // }

    A2FormProceed() {
      // if(this.orderDetails?.productGroup == 'REMITTANCE' || this.orderDetails?.orderType == 'CASH_PURCHASE' || (this.orderDetails?.productGroup == 'FOREX')) {
        this.showIframeForEsign();
      /* } else {
        this.otpVerification();
      } */
    }  

    // showIframeForEsign() {
    //   let isAKCDone = sessionStorage.getItem(ConstantsKey.ORDER_DETAILS_PAGE_ESIGN_ACK);
    //   if(isAKCDone == "TRUE") {
    //     /* if(this.orderDetails?.productGroup == 'FOREX' && this.orderDetails?.orderType != 'CASH_PURCHASE' && this.cardOrderType.cardType == 'smartCurrencyCard') {

    //     } else { */
    //       this.showESignIframe = true;
    //     /* } */
    //   } else {
    //     this.toast.error("Kindly accept the Terms & conditions");
    //   }
    // }

    async showIframeForEsign() {

      let isAKCDone = sessionStorage.getItem(ConstantsKey.ORDER_DETAILS_PAGE_ESIGN_ACK);
      if(isAKCDone == "TRUE") {

        let requestAadhaarEsignDetail = new RequestAadhaarEsignDetailOrder();
        requestAadhaarEsignDetail.orderId = this.orderId;
        requestAadhaarEsignDetail.initiateAadharSigning = true;
        this.showLoader = true;    
        const respEsign = await this.cardService.cashoutEsignOrder(requestAadhaarEsignDetail).toPromise();
        this.esignResp = JSON.parse(JSON.stringify(respEsign.body));
        this.esignUrl = this.esignResp.url;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.esignUrl);
        this.showESignIframe = true;
        this.showLoader = false;
      } else {
        this.toast.error("Kindly accept the Terms & conditions");        
      }
    } 
    
     async aadharEsignDocumentDetails() {
    
        let requestAadhaarEsignDetail = new RequestAadhaarEsignDetail();
        requestAadhaarEsignDetail.consumerId = localStorage.getItem(
          ConstantsKey.CONSUMER_ID
        );
        requestAadhaarEsignDetail.refOrderId = this.orderId;
          // this.cartItemsResponse["cartDetails"]["refOrderId"];
    
        this.remittanceService
          .getA2FormSignedDoc(requestAadhaarEsignDetail)
          .subscribe(async (resp) => {
            var resAadhaarEsignDetail = JSON.parse(JSON.stringify(resp.body));
            if (resp.status == 200) {
              if (
                resAadhaarEsignDetail.esignFileUrl &&
                resAadhaarEsignDetail.esignFileUrl != null &&
                resAadhaarEsignDetail.esignFileUrl != ""
              ) {
               
    
                this.showLoader = false;
                if(this.isSurrenderOrder){
                   this.router.navigate(['/currency-notes-order-success', this.orderId]);
                }else{
                    this.router.navigate(['/sit-back-relax', this.orderId]);
                }
               // this.modalReference = this.modalService.open(this.rateUsModal, { centered: true, backdrop: 'static' } );            
              } else {
                this.toast.error("Please esign document properly.");
              }
            } else {
              this.toast.error("Please esign document properly!");
            }
          });
      }

}
